// events we are going to use
import React, { useState, useEffect, useRef } from 'react'

// what we agoing to use
import { Modal, Form, Button } from 'semantic-ui-react'

// need to add all API calls here:
import { GetHotelKeyEncoders, PostKeyRequest, GetHotelInterfaces } from '../../api/services/pms'

import PropTypes from "prop-types";
import { useLoader } from '../../hooks/useLoader';



const KeyMakerPopup = (reservationVM) => {

    // ver 3.7 // in order to get latest update please do HARD RESET to the page
    // variable and SET declaration with initial empty Data
    const [encoders, setEncoders] = useState([])
    const [singleEncoder, setSingleEncoder] = useState([])

    const [reservation, setReservation] = useState(reservationVM)

    // variable and SET declaration with initial Data from PROP
    const [checkInDate, setCheckInDate] = useState()
    const [checkOutDate, setCheckOutDate] = useState()

    const [checkInTime, setCheckInTime] = useState()
    const [checkOutTime, setCheckOutTime] = useState()

    const [guestName, setGuestName] = useState()
    const [roomName, setRoomName] = useState()

    const [open, setOpen] = useState(false)
    const [visibleIcon, setVisibleIcon] = useState(false)

    // variable and SET declaration with initial Data 
    const [copies, setCopies] = useState(1)

    const loader = useLoader()

    const iconEl = useRef(null);

    useEffect(()=>{
        let parent = document.querySelector("#keymakersideicon")
        if (parent) {
            parent.style.display = visibleIcon?"":"none"
        }
    }, [visibleIcon])

    useEffect(() => {
        window.externalsetdata = (reservation) => {
            // we could check if data is reservation types
            setReservation(reservation)
        }
        window.externalOpenKeyMaker = (reservationExt)=>{
            setReservation(reservationExt)
            setOpen(true)
        }
    }, [])
    
    // In order to get data ON LOAD event when reservation updates
    useEffect(() => {
        try {
            
            if (reservation && reservation.HotelId)
            {
                (async () => {
                    const interfaces = await GetHotelInterfaces({ PMSHotelIDs: [reservation.HotelId] })
                    if(interfaces.filter(value=> value.Id==9).length > 0) // according to the enum public enum EInterfaceTypes: VisionLine = 9
                    {
                        const encoders = await GetHotelKeyEncoders({ PMSHotelID: reservation.HotelId })
                        setVisibleIcon(true)
                        setEncoders(encoders) 
                    }
                })()

                setCheckInDate(formatDateString(reservation.CheckInDate))
                setCheckOutDate(formatDateString(reservation.CheckOutDate))

                setGuestName(formatGuestName(reservation))
                setRoomName(formatRoomName(reservation))

                setCheckInTime(reservation.Eta)
                setCheckOutTime(reservation.Etd)
            }
        } catch (error) {
            console.error(error)
        }
    }, [reservation])

    // supports value change handling
    const changeCheckОutTime = (value) => {
        setCheckOutTime(value)
    }

    function formatRoomName(reservation) {
        var roomName = "";

        try {
            if (reservation && reservation.Room) {
                roomName = reservation.Room.Number;
            }

            return roomName;
        }
        catch (error) {
            console.error(error)
        }

        return roomName;
    }

    function formatGuestName(reservation) {
        var guest = "";

        try {
            if (reservation && reservation.Guest) {
                guest = reservation.Guest.FirstName + " " + reservation.Guest.LastName;
            }

            return guest;
        }
        catch (error) {
            console.error(error)
        }

        return guest;
    }

    function pad(n) {
        return n < 10 ? '0' + n : n;
    }

    function formatDateString(value) {
        if (value === undefined) {
            return "";
        }

        var date = new Date(value);
        var day = date.getDate();
        var month = date.getMonth();
        var year = date.getFullYear();

        var dateString = year + "-" + pad(month + 1) + "-" + pad(day);

        return dateString
    }



    const changeCheckInDate = (value) => {
        setCheckInDate(value)
    }

    const onClickOpen = ()=>{
        // Check if should open or show message
        if (reservation && reservation.Id != undefined) {
            setOpen(true)
        } else {
            window.optima.UI.messages.warning(window.optima.resourceManager.messages.ReservationLeftMenuFunctuanalityAvailableOnlyForSavedReservations);
        }
            
    }
    if (visibleIcon) {
    return (
        <Modal
            size="small"
            onClose={()=>setOpen(false)}
            onOpen={()=>setSingleEncoder([])}
            open={open}
            trigger={
                //<span className="icon-key" style={{visibility: visibleIcon ? 'visible' : 'hidden' }}
                <span className="icon-key"
                tooltip-animation='true' tooltip-placement='top' uib-tooltip="Key Maker" onClick={()=>onClickOpen()}></span>
            }
        >
            <Modal.Header>Key Maker</Modal.Header>
            <Modal.Content>
                <Form >
                    <Form.Group widths="2">
                        <Form.Input label="Reservation Number" value={reservation ? reservation.Number : ""} readOnly={true} />
                        <Form.Input label="Guest Name" value={guestName} readOnly={true} />
                    </Form.Group>
                    <Form.Group widths="2">
                        <Form.Input label="Check In Date" icon="calendar" value={checkInDate} readOnly={true} onChange={(e, data) => changeCheckInDate(data.value)} />
                        <Form.Input label="Check-In Time" icon="clock" iconPosition="left" readOnly={true} value={checkInTime} />
                    </Form.Group>
                    <Form.Group widths="2">
                        <Form.Input label="Check Out Date" icon="calendar" value={checkOutDate} readOnly={true} onChange={event => setCheckOutDate(event.target.value)} />
                        <Form.Input label="Check-Out Time" icon="clock" iconPosition="left" value={checkOutTime} onChange={(e, data) => changeCheckОutTime(data.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input width="8" label="Room" readOnly={true} value={roomName} />
                        <Form.Input width="2" label="Copies" type="number" readOnly={false} value={copies} min="1" onChange={(e, data) => setCopies(data.value)} />
                        <Form.Select width="6" label="Encoder" placeholder="Select encoder" id="mySelect" options={
                            encoders.map(encoder => {
                                return {
                                    text: encoder.EncoderName,
                                    value: encoder.EncoderID,
                                    key: encoder.EncoderID
                                }
                            })
                        }
                            onChange={(e, data) => setSingleEncoder(data.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={() => setOpen(false)}>Close</Button>
                <Button positive disabled={!singleEncoder.length} 
                    onClick={
                        async () => {
                            loader(true)
                            if (!singleEncoder.length) {
                                window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorPleaseSelectEncoder);
                            }
                            else {

                                    var result = null;
                                    try 
                                    {
                                        result =
                                        await PostKeyRequest(
                                            {
                                                HotelID: reservation.HotelId,
                                                PmsEventType: 9, //PmsKeyEvent enum
                                                ActionCode: 0, //New Key according to KeyActionCode enum
                                                EncoderID: singleEncoder,
                                                Copies: copies,
                                                PMSRoomIDs: reservation.RoomId,
                                                ValidFrom: checkInDate + ' ' + checkInTime,
                                                ValidUntil: checkOutDate + ' ' + checkOutTime,
                                                FolioNumber: reservation.FolioNumber
                                            });

                                    if (result && result.Result && result.Result.length > 0)
                                     {

                                        if(result.Result[0].IsSuccessful == true)
                                        {
                                            setOpen(false);
                                            window.optima.UI.messages.success(window.optima.resourceManager.messages.KeyCreatedSuccessfully);

                                            console.log("Key created successfully");   
                                        }
                                        else
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Result[0].StatusCode + ". " + result.Result[0].MessageText);
                                        }     
                                    }
                                    else
                                    {
                                        if(result && result.Errors && result.Errors.length > 0)
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Errors[0].Code + ". " + result.Errors[0].Message);    
                                        }
                                        else
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey); 
                                        }
                                    }
                                        
                                }
                                
                                catch (error)
                                {

                                    window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey); 
                                    
                                    console.error(error);
                                }
                                loader(false)
                            }
                        }
                    }
                >Create New Key</Button>
                <Button positive disabled={!singleEncoder.length}
                    onClick={
                        async () => {

                            loader(true)
                            if (!singleEncoder.length) {
                                window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorPleaseSelectEncoder);
                            }
                            else {

                                    var result = null;
                                    try 
                                    {
                                        result =
                                        await PostKeyRequest(
                                            {
                                                HotelID: reservation.HotelId,
                                                PmsEventType: 9, //PmsKeyEvent enum
                                                ActionCode: 1, //Copy Key according to KeyActionCode enum
                                                EncoderID: singleEncoder,
                                                Copies: copies,
                                                PMSRoomIDs: reservation.RoomId,
                                                ValidFrom: checkInDate + ' ' + checkInTime,
                                                ValidUntil: checkOutDate + ' ' + checkOutTime,
                                                FolioNumber: reservation.FolioNumber
                                            });

                                    if (result && result.Result && result.Result.length > 0)
                                     {

                                        if(result.Result[0].IsSuccessful == true)
                                        {
                                            setOpen(false);
                                            window.optima.UI.messages.success(window.optima.resourceManager.messages.KeyCreatedSuccessfully);

                                            console.log("Copy Key copied successfully");   
                                        }
                                        else
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Result[0].StatusCode + ". " + result.Result[0].MessageText);
                                        
                                            console.error(window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Result[0].StatusCode + ". " + result.Result[0].MessageText);
                                        }     
                                    }
                                    else
                                    {
                                        if(result && result.Errors && result.Errors.length > 0)
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Errors[0].Code+ ". " + result.Errors[0].Message);    

                                            console.error(window.optima.resourceManager.messages.KeyErrorUnableToCreateKey + result.Errors[0].Code + ". " + result.Errors[0].Message);
                                        }
                                        else
                                        {
                                            window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey); 

                                            console.error(window.optima.resourceManager.messages.KeyErrorUnableToCreateKey);
                                        }
                                    }
                                        
                                }
                                
                                catch (error)
                                {

                                    window.optima.UI.messages.warning('', window.optima.resourceManager.messages.KeyErrorUnableToCreateKey); 
                                    
                                    console.error(error);
                                }
                                loader(false)
                            }
                        }
                    }
                >Create Copy Key</Button>
            </Modal.Actions>
        </Modal >

    ) 
    } else return (
        <div ref={iconEl}></div>
    )
}

KeyMakerPopup.propTypes = {
    reservation: PropTypes.object
}

export default KeyMakerPopup